import { Endpoint } from '@business/api/endpoint';
import { TMChangeOrderTypeId, TMChangeOrderTypeRequest, TMChangeOrderTypeResponse } from '@business/entities/tm';

export function fetchChangeOrderTypes() {
  return Endpoint.get<TMChangeOrderTypeResponse[]>(`@gc/tm-change-order-types`);
}

export function createChangeOrderType(data: TMChangeOrderTypeRequest) {
  return Endpoint.post<TMChangeOrderTypeResponse>(`@gc/tm-change-order-types`, { data });
}

export function updateChangeOrderType(id: TMChangeOrderTypeId, data: TMChangeOrderTypeRequest) {
  return Endpoint.patch<TMChangeOrderTypeResponse>(`@gc/tm-change-order-types/${id}`, { data });
}

export function deleteChangeOrderType(id: TMChangeOrderTypeId) {
  return Endpoint.delete<{ success: boolean }>(`@gc/tm-change-order-types/${id}`);
}
